import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './TaskCard.module.css';
import { TaskCard as TaskCardType } from '../../types';
import { ProgressBar } from '../../../../Components/ProgressBar/ProgressBar';
import { getTicketWord } from '../../../../Services/utils';
import dreamcoinLogo from "/dreamcoin-logo.svg";
import ticketLogo from "/spin.svg";
import arrowRight from "/arrow.svg";
interface TaskCardProps {
  task: TaskCardType;
  onModalShow?: () => void;
}

export const TaskCard: React.FC<TaskCardProps> = ({ task, onModalShow }) => {
  const navigate = useNavigate();
  console.log(task);
  
  const handleCardClick = () => {
    if (task.type === 'daily-bonus' && onModalShow) {
      console.log("dailyReward");
      onModalShow();
    } else if (task.group === "combined") {
      navigate(`/quests/${task.type}`, {
        state: { groupId: task.id }
      });
    } else {
      navigate(`/tasks/${task.type}`, {
        state: { groupId: task.id }
      });
    }
  };

  // Определяем класс в зависимости от типа задания
  let typeClass = '';
  if (task.type === 'sponsors') {
    typeClass = styles.sponsorsLogo;
  } else if (task.type === 'partners') {
    typeClass = styles.partnersLogo;
  } else if (task.type === 'quest-daily') {
    typeClass = styles['quest-daily'] || styles.questDailyLogo;
  } else if (task.type === 'daily-bonus') {
    typeClass = styles['daily-bonus'] || styles.dailyBonusLogo;
  }

  const cardImageClass = `${styles.cardImage} ${typeClass}`;
  
  return (
    <div 
      className={styles.card}
      onClick={handleCardClick}
    >
      <div className={styles.cardContent}>
        <div className={cardImageClass}>
          <img src={task.image} alt={task.title} />
        </div>
        <div className={styles.cardContentText}>
          <h4>{task.title}</h4>
          {task.rewards && Array.isArray(task.rewards) && task.rewards.length > 0 && (
            <div className={styles.rewards}>
              
              {task.type === 'sponsors' && (
                <span className={styles.sponsors}>До:</span>
              )}
              {task.rewards.map((reward) => (
                
                <div key={reward.type} className={styles.reward}>
                  {reward.type === 'DC' && reward.amount > 0 && (
                    <div className={styles.dcReward}>
                      {reward.amount} DC <img src={dreamcoinLogo} alt="DC" />
                    </div>
                  )}
                  {reward.type === 'tickets' && reward.amount > 0 && (
                    <div className={styles.ticketReward}>
                      {reward.amount} {getTicketWord(reward.amount.toString())} 
                      <img src={ticketLogo} alt="Tickets" />
                    </div>
                  )}
                </div>

              ))}
            </div>
          )}
        </div>
        <div className={styles.cardButton}>
          <img src={arrowRight} alt="arrowRight" />
        </div>
      </div>
      {task.progress && task.progress.total > 0 && (
        <ProgressBar 
          current={task.progress.current}
          total={task.progress.total}
        />
      )}
    </div>
  );
};
